// admin模块用到了dayjs的utc方法，需保证utc的拓展加载在一切其他import前
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

// 使dayjs支持utc方法
dayjs.extend(utc);

/**
 * admin 项目入口
 */

import('./bootstrap');
